<div class="modal">
  <div class="dialog-container">
    <h1>
      <span>{{ beneficiary ? "CPF já vinculado" : "CPF não vinculado" }}</span>
      <img (click)="close()" class="close-dialog" src="./assets/icons/gray-close-icon.svg" />
    </h1>
  </div>
  <div class="right-container">
    <p class="text">{{ beneficiary ? "O CPF já está cadastrado no portal." : "O CPF ainda não foi cadastrado no portal." }}</p>
    <p class="text" *ngIf="hasCompany()">Vinculado na(s) empresa(s):</p>
    <ul>
      <li *ngFor="let company of companies">
        <div class="company">
          <span class="company-name">{{ company.getCorporateName() }}</span>
          <span class="company-cnpj"> CNPJ: {{ company.getFiscalNumber() | companyFederalNumber }} </span>
        </div>
      </li>
    </ul>
  </div>
</div>
